
import { Component, Vue } from "vue-property-decorator";
import { XinWbEmployeeOperateRenewContract } from '@xin/xin-workbench'
@Component({
  name: "EmployeeOperateMixin",
  components:{
    XinWbEmployeeOperateRenewContract
  }
})
export default class EmployeeOperateMixin extends Vue {

  entryOperateData:any = {} //入职操作特殊数据存储

  //员工卡片操作
  employeeOperate(operateKey:string,data:any){
    console.log(operateKey);
    const { employeeId,employeeName,opControls } = data

    switch(operateKey){
      case 'entry':
        console.log('入职，有limit校验');
        this.getEmployeeLimit().then((res:any) => {
          this.entryOperateData.employeeLimitStatus = res.employeeLimitStatus
          if (res.employeeLimitStatus == 1) {
            //@ts-ignore
            window.location.href = `/employee/entry?employeeId=${employeeId}`
          } else {
            this.entryOperateData.nextRoute = `/employee/entry?employeeId=${employeeId}`;
            const confirmButtonText = res.employeeLimitStatus === 2 ? "知道了，继续操作" : "联系客服";
            this.showEmployeeLimitDialog({
              callback: this.handleNextStep,
              confirmButtonText,
              cancelButtonText:'取消'
            },
            res.employeeLimitStatus,
            res.signEmployeeSize);
          }
        });
        break;
      case 'dismission':
        console.log('离职');
        window.location.href = `/employee/dismission?employeeId=${employeeId}`
        break;
      case 'regular':
        console.log('转正');
        window.location.href = `/employee/regular?employeeId=${employeeId}`
        break;
      case 'renewContract':
        console.log('续签',data);
        //@ts-ignore
        this.$refs.employeeOperateRenewContractRef.openLaunchContract({
          operateEmployeeId:employeeId,
          currentEmployeeObj:{
            employeeId,
            employeeName
          },
          originalRenewContract: opControls ? opControls[0].businessVals : {},
          text:window.$xinI18n('续签','Home-stat-xuqian'),
          isShowAddContract:true
        })
        break;
      default:
        break
    }
    console.log('-----------员工操作-----------',operateKey,data);
    
  }

  //员工-入职检测上线
  getEmployeeLimit(){
    return Vue.http({
      url: '/employee/service/ajax-get-employee-limit-level',
      method: 'post'
    }).then((reply: any) => {
      const res = reply.data;
      if(res.status){
        return {
          employeeLimitStatus: res.data.limitLevel,
          signEmployeeSize: res.data.signEmployeeSize
        }
      }else{
        return {}
      }
    })
  }

  //入职上线提醒弹窗
  showEmployeeLimitDialog(config: {callback: any, cancelButtonText: string, confirmButtonText: string},employeeLimitStatus: 1 | 2 | 3, signEmployeeSize: number) {
    let {callback, cancelButtonText , confirmButtonText} = config;
    confirmButtonText = confirmButtonText || (employeeLimitStatus === 2 ? '立即增购' : '知道了')
    let text = ''
    switch(employeeLimitStatus) {
      case 2:
        text = `您的账户在职员工已超过签约员工数量上限${signEmployeeSize}，请及时联系客户经理或“小薪在线”增购`
        break
      case 3:
        text = `您的账户在职员工已超出签约员工数量上限${signEmployeeSize}，无法新增，请及时联系客户经理或“小薪在线”增购`
        break
      default:
        break
    }
    text && this.$alert(`
      <div class="employee-limit-content">
        <img src="//static.xinrenxinshi.com/admin/employee-limit.png">
        <p class="tip">${text}</p>
      </div>`, '',
      {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        cancelButtonText: cancelButtonText || '取消',
        confirmButtonText,
        callback: callback || (() => {return}),
      }
    )
  }

  handleNextStep(action: string){
      if(action != 'confirm'){
        return;
      }
      if(this.entryOperateData.employeeLimitStatus === 2){
        window.location.href = this.entryOperateData.nextRoute;
      } else {
        const el: HTMLElement = document.getElementById('zhichi-service') as HTMLElement;
        el && el.click();
      }
    }
}